// Providers.js
import React from 'react';
import { SidebarProvider } from './Context/SidebarContext';
import { LanguageProvider } from './Context/LanguageContext';
import { ToastProvider } from './Context/ToastContext';
import { AuthProvider } from './Context/AuthContext';
import { CartProvider } from './Context/CartContext';
import { StoreProvider } from './Context/StoreContext';
import { PublicSettingsProvider } from './Context/PublicSettingsContext';
import { ThemeProvider } from './Context/ThemeContext';

const AppProviders = ({ children }) => (
    <StoreProvider>
        <PublicSettingsProvider>
            <ToastProvider>
                <AuthProvider>
                    <CartProvider>
                        <SidebarProvider>
                            <LanguageProvider>
                                <ThemeProvider>
                                    {children}
                                </ThemeProvider>
                            </LanguageProvider>
                        </SidebarProvider>
                    </CartProvider>
                </AuthProvider>
            </ToastProvider>
        </PublicSettingsProvider>
    </StoreProvider>
);

export default AppProviders;
